import { useSelector } from "react-redux";
import isEqual from "lodash.isequal";

import {
  selectSwiftWireTemplates,
  selectOneSwiftWireTemplate,
  selectSortedSwiftWireTemplateIds,
} from "./selectors";

export const useSwiftWireTemplates = () => {
  return useSelector(selectSwiftWireTemplates);
};

export const useSortedSwiftWireTemplateIds = () => {
  return useSelector(selectSortedSwiftWireTemplateIds);
};

export const useOneSwiftWireTemplate = (
  swiftWireTemplateId?: API.SwiftWireTemplateId,
) => {
  return useSelector((state) => {
    return selectOneSwiftWireTemplate(state, swiftWireTemplateId);
  }, isEqual);
};
